export default __webpack_public_path__ + "static/media/nLighten_logo_gold.2116372e.svg";